// Product card pack switch (snippets/product-card.liquid): a track with a sliding thumb. Tap a size,
// drag the thumb or use the arrow keys; the card then shows that pack's price bar, % OFF tab, unit
// price and ADD / stepper (each pack has its own, run by assets/cart.js). The new price counts up or
// down from the old one. Listens on the document, so cards that load later (infinite scroll, rails)
// work without set-up.

const MONEY = document.querySelector('[data-money-format]')?.dataset.moneyFormat || '{{amount}}';
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const COUNT_MS = 320;

/** 72500 (paise) → "₹725": the shop's money format, as Liquid's money filter prints it. */
function money(cents) {
  return MONEY.replace(/\{\{\s*(\w+)\s*\}\}/, (_, name) => {
    const text = name.includes('no_decimals') ? String(Math.round(cents / 100)) : (cents / 100).toFixed(2);
    const [whole, decimals] = text.split('.');
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return decimals ? `${grouped}.${decimals}` : grouped;
  });
}

function countTo(el, from, to) {
  // The price as Liquid printed it, kept once: a fast switch back reads the element mid-count.
  el.dataset.final ??= el.textContent;
  const final = el.dataset.final;
  if (reduceMotion.matches || from === to) return;
  const start = performance.now();
  cancelAnimationFrame(el.countFrame);
  const step = (now) => {
    const t = Math.min(1, (now - start) / COUNT_MS);
    const eased = 1 - (1 - t) ** 3;
    el.textContent = t < 1 ? money(from + (to - from) * eased) : final;
    if (t < 1) el.countFrame = requestAnimationFrame(step);
  };
  el.countFrame = requestAnimationFrame(step);
}

function choose(track, index, { focus = false } = {}) {
  const card = track.closest('[data-card]');
  const options = [...track.querySelectorAll('[data-card-choose]')];
  const current = options.findIndex((option) => option.getAttribute('aria-checked') === 'true');
  track.style.setProperty('--i', index);
  track.querySelector('.card__thumb').style.transform = '';
  if (index === current) return;
  options.forEach((option, i) => {
    option.setAttribute('aria-checked', String(i === index));
    option.tabIndex = i === index ? 0 : -1;
  });
  if (focus) options[index].focus();
  card.querySelectorAll('[data-card-pack]').forEach((part) => {
    part.hidden = part.dataset.cardPack !== String(index);
  });
  const amount = (i) => Number(card.querySelector(`.card__offer[data-card-pack="${i}"] [data-card-amount]`)?.dataset.cardAmount);
  const shown = card.querySelector(`.card__offer[data-card-pack="${index}"] [data-card-amount]`);
  if (shown && current >= 0) countTo(shown, amount(current), amount(index));
}

document.addEventListener('click', (event) => {
  const option = event.target.closest('[data-card-choose]');
  if (!option) return;
  const track = option.closest('[data-card-switch]');
  if (track.dragged) {
    track.dragged = false;
    return;
  }
  choose(track, Number(option.dataset.cardChoose));
});

// Narrow cards hide the third size (CSS), so only the sizes on screen count.
const shownSizes = (track) => [...track.querySelectorAll('[data-card-choose]')].filter((option) => option.offsetParent !== null);

document.addEventListener('keydown', (event) => {
  const option = event.target.closest('[data-card-choose]');
  const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
  if (!option || !step) return;
  event.preventDefault();
  const track = option.closest('[data-card-switch]');
  const count = shownSizes(track).length;
  choose(track, (Number(option.dataset.cardChoose) + step + count) % count, { focus: true });
});

// Drag: the thumb follows the finger along the track and settles on the nearest size. A short move
// stays a tap, and an upward or downward swipe scrolls the page (touch-action: pan-y in the CSS).
document.addEventListener('pointerdown', (event) => {
  const track = event.target.closest('[data-card-switch]');
  if (!track || event.button > 0) return;
  const thumb = track.querySelector('.card__thumb');
  if (event.target.closest('.card__switch-more')) return;
  const count = shownSizes(track).length;
  const box = track.getBoundingClientRect();
  const more = parseFloat(getComputedStyle(track).getPropertyValue('--more')) || 0;
  const width = (box.width - 6 - more) / count;
  const at = (x) => Math.max(0, Math.min(width * (count - 1), x - box.left - 3 - width / 2));
  const startX = event.clientX;
  let moving = false;
  const move = (e) => {
    if (!moving && Math.abs(e.clientX - startX) < 6) return;
    if (!moving) {
      moving = true;
      track.setPointerCapture?.(e.pointerId);
      track.classList.add('is-dragging');
    }
    thumb.style.transform = `translateX(${at(e.clientX)}px)`;
  };
  const end = (e) => {
    track.removeEventListener('pointermove', move);
    track.removeEventListener('pointerup', end);
    track.removeEventListener('pointercancel', end);
    if (!moving) return;
    track.classList.remove('is-dragging');
    track.dragged = e.type === 'pointerup';
    // The click that ends a captured drag may land on the track, not a size: clear the flag after it,
    // so the next tap or Enter is not swallowed.
    if (track.dragged) setTimeout(() => (track.dragged = false));
    choose(track, Math.round(at(e.clientX) / width));
  };
  track.addEventListener('pointermove', move);
  track.addEventListener('pointerup', end);
  track.addEventListener('pointercancel', end);
});
